import { Injectable } from "@angular/core";
import * as currencies from "../currencies.json";

@Injectable()
export class CurrencyService {
  constructor() {}

  getCurrencies() {
    return currencies;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/currency.service.ts